export default function AboutHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-emerald-50 via-white to-teal-50">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-building-line"></i>
            <span>Company Overview</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            会社概要
          </h1>
          
          <p className="text-xl text-gray-600 leading-relaxed mb-8">
            地域資源を活かし、持続可能な地域社会をつくる。<br />
            大学研究と環境技術を基盤とした信頼性の高い企業として、<br />
            地域社会と共に持続可能な未来を推進しています。
          </p>

          <div className="flex items-center justify-center gap-8 pt-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-1">2014</div>
              <div className="text-sm text-gray-600">設立年</div>
            </div>
            <div className="w-px h-12 bg-gray-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-1">2拠点</div>
              <div className="text-sm text-gray-600">事業所</div>
            </div>
            <div className="w-px h-12 bg-gray-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-emerald-600 mb-1">5名</div>
              <div className="text-sm text-gray-600">役員・顧問</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}